export default __webpack_public_path__ + "static/planful-logo-latest-svg-12c7cee2bf3ea0aa0d255f2c604ac67a.svg";